/**
 * Shared hook that computes progressive navigation tiers.
 * Used by both BottomNav (mobile) and any future nav consumers
 * to avoid duplicating the disclosure logic.
 */
import { useAuthStore, selectUser } from '../stores/authStore'
import { useDecks } from './useDecks'

export interface ProgressiveNavState {
  /** Total number of decks owned by the user */
  deckTotal: number
  /** True once user has 3+ decks OR has completed at least one session */
  isEngaged: boolean
  /** True if user has an active Pro plan */
  isPro: boolean
  /** Total cards due across all decks (for badges) */
  totalDue: number
}

export function useProgressiveNav(): ProgressiveNavState {
  const user = useAuthStore(selectUser)
  const { data: decksData } = useDecks(1, 100)

  const deckTotal = decksData?.total ?? 0
  const isPro = user?.plan === 'pro'
  // words_known_count > 0 is the same proxy used by the sidebar
  const hasStudied = (user?.words_known_count ?? 0) > 0
  const isEngaged = deckTotal >= 3 || hasStudied
  const totalDue = (decksData?.items ?? []).reduce(
    (sum, d) => sum + (d.due_count ?? 0),
    0,
  )

  return { deckTotal, isPro, isEngaged, totalDue }
}
